import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_MEDICAL_RECORD_URL
});
addAuthInterceptors(http);
export const generate3dModel = async ({
  modelReferenceId,
  ...params
}) => {
  const {
    data
  } = await http.get(`/medical-records/jaw-findings/${modelReferenceId}/jaw3d`, {
    params
  });
  return data;
};
export const getToothFindingsSummary = async personReferenceId => {
  const {
    data
  } = await http.get('/medical-records/jaw-findings/summary', {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getToothFindingsById = async (referenceId, personReferenceId) => {
  const {
    data
  } = await http.get(`/medical-records/jaw-findings/${referenceId}`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getPatientHistory = async personReferenceId => {
  const {
    data
  } = await http.get(`/patient-history/v2`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getPSISummary = async personReferenceId => {
  const {
    data
  } = await http.get(`/external/medical-records/dental-psi-diagnosis`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getPSIById = async (referenceId, personReferenceId) => {
  const {
    data
  } = await http.get(`/external/medical-records/dental-psi-diagnosis/${referenceId}`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getImagingSummary = async (personReferenceId, page, size) => {
  const {
    data
  } = await http.get(`/external/medical-records/images?page=${page}&size=${size}`, {
    params: {
      personReferenceId
    }
  });
  return data;
};
export const getImage = async (referenceId, type) => {
  const {
    data
  } = await http.get(`/external/medical-records/images/${referenceId}`, {
    params: {
      type
    }
  });
  return data;
};
export const getVisitation = async appointmentReferenceId => {
  const {
    data
  } = await http.get(`/patient-history/v2/visitation/${appointmentReferenceId}`);
  return data;
};